import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a9794ac&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9794ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a9794ac')) {
      api.createRecord('1a9794ac', component.options)
    } else {
      api.reload('1a9794ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1a9794ac&scoped=true&", function () {
      api.rerender('1a9794ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/work_order/config/index.vue"
export default component.exports